module.exports = __webpack_public_path__ + "images/fc23b90236f87b11147810f35f4c5293.svg";